module.exports = __webpack_public_path__ + "img/cover_photo.2fa118d8.jpg";